import React from "react";
import { ImageList, ImageListItem } from "@mui/material";
import { PageLayout } from "../../components/PageLayout/PageLayout";
import Seo from "../../components/Seo/Seo";
import { PAGE_SEO } from "../../seo/seoConstants";
import WhatsAppInfoSection from "../../components/WhatsAppInfoSection/WhatsAppInfoSection";
import { IMAGE_LIST_COLS, IMAGE_LIST_GAP, WHATSAPP_INFO } from "../shared/constants";
import { CommonBoxStyles, ServiceImage } from "../shared/styledComponents";
import { resolveAssetUrl } from "../../utils/assets";

// Bucket keys, not URLs (EB-514) — resolved at render time.
const PREFIX = "detalle-instalacion-de-camaras-de-seguridad";

const images = [
  `${PREFIX}/banner-instalacion-de-camaras-de-seguridad.jpg`,
  `${PREFIX}/servicios-camaras-de-seguridad.jpg`,
];

export const SecurityCameraInstallingPage: React.FC = () => {
  return (
    <PageLayout>
      <Seo {...PAGE_SEO["/instalacion-de-camaras-de-seguridad"]} />
      <CommonBoxStyles>
        <ImageList cols={IMAGE_LIST_COLS} gap={IMAGE_LIST_GAP}>
          {images.map((src, index) => (
            <ImageListItem key={index}>
              <ServiceImage
                src={resolveAssetUrl(src)}
                alt={`security-camera-installing-${index}`}
                loading="lazy"
              />
            </ImageListItem>
          ))}
        </ImageList>
        <WhatsAppInfoSection {...WHATSAPP_INFO.securityCameras} />
      </CommonBoxStyles>
    </PageLayout>
  );
};

export default SecurityCameraInstallingPage;
